import { ErrorTriangle } from '@hendrx/icons/ErrorTriangle';
import { Tooltip } from '@mantine/core';
import isEmpty from 'lodash/isEmpty';
import React, { memo, ReactNode } from 'react';

import classes from './ErrorIndicator.module.scss';

type ErrorIndicatorProps = {
  children: ReactNode;
  errors?: Record<string, Array<string>>;
  hasErrors?: boolean;
  tooltip?: string;
};

export const ErrorIndicator = memo(function UIIndicators(props: ErrorIndicatorProps) {
  const { children, errors, hasErrors, tooltip } = props;
  const showErrorIndicator = hasErrors || !isEmpty(errors);

  const ErrorIcon = <ErrorTriangle data-testid="validation-error-triangle" className={classes.errorIcon} />;

  return (
    <>
      {showErrorIndicator && (tooltip ? <Tooltip label={tooltip}>{ErrorIcon}</Tooltip> : ErrorIcon)}
      {children}
    </>
  );
});
